import React, { useRef } from 'react';
import { Col, Row } from 'antd';

import { HorizontalButtons } from './components/HorizontalButtons';
import { StepIcon } from './components/StepIcon';
import { DIRECTION, Direction } from './types';
import { Step } from '@/hooks';

import * as S from './styles';

interface StepsNavigationProps {
	steps: Step[];
	currentStep: number;
	isComplete: boolean;
	reachedStep?: number;
	direction?: Direction;
	isConsolidated?: boolean;
	onStepNagivationClick: (step: number) => Promise<void> | void;
}

export function StepsNavigation({
	steps,
	isComplete,
	currentStep,
	reachedStep,
	isConsolidated = false,
	onStepNagivationClick,
	direction = DIRECTION.VERTICAL
}: Readonly<StepsNavigationProps>) {
	const elementRef = useRef<HTMLDivElement | null>(null);

	const mappedSteps = steps.map((item, index) => {
		item.icon = (
			<StepIcon
				key={item.name}
				position={index}
				isComplete={isComplete}
				currentStep={currentStep}
				reachedStep={reachedStep}
				name={item.description}
				isConsolidated={isConsolidated}
				onStepNagivationClick={onStepNagivationClick}
			/>
		);
		return item;
	});

	if (direction === DIRECTION.VERTICAL || steps.length <= 12) {
		return (
			<Row justify="center">
				<S.Container xs={24}>
					<Row justify="center">
						<Col xs={20}>
							<S.CustomSteps
								size="small"
								items={mappedSteps}
								direction={direction}
								current={currentStep}
								$disabled={isConsolidated}
							/>
						</Col>
					</Row>
				</S.Container>
			</Row>
		);
	}

	return (
		<Row justify="center">
			<S.Container xs={24}>
				<HorizontalButtons elementRef={elementRef}>
					<Col xs={20}>
						<div ref={elementRef} style={{ overflowX: 'hidden' }}>
							<S.CustomSteps
								size="small"
								items={mappedSteps}
								direction={direction}
								current={currentStep}
								$disabled={isConsolidated}
							/>
						</div>
					</Col>
				</HorizontalButtons>
			</S.Container>
		</Row>
	);
}
